module.exports = __webpack_public_path__ + "img/dm-group-logo.3598a5b0.png";